import axios from '../utils/axios'

// 获取搜索列表数据
export function noLoginSouhuoList(data) {
    return axios({
        url: '/NoAuth/SaleIndex/SaleCentreNoLogin',
        method: 'post',
        data: data
    })
}
export function loginSouhuoList(data) {
    return axios({
        url: '/Sale/Sale/SaleCentre',
        method: 'post',
        data: data
    })
}
// 首页特卖排序表IsFavorite字段独立接口
export function IsFavorite(data) {
    return axios({
        url: '/SaleV2/ProductFavorite/IsFavorite',
        method: 'post',
        data: data
    })
}
export function BannerList(data = {}) {
    return axios({
        url: '/NoAuth/SaleIndex/BannerList',
        method: 'POST',
        data: data
    })
}
// 获取分类数据
export function getCategory(data = {}) {
    return axios({
        url: '/NoAuth/Product/GetSCategoryLeve2',
        method: 'POST',
        params: data
    })
}
// // 获取品牌
// export function loginBrandData (query) {
//   return axios({
//     url: '/Sale/Sale/BrandName',
//     method: 'GET',
//     params: query
//   })
// }
// export function noLoginBrandData (query) {
//   return axios({
//     url: '/NoAuth/SaleIndex/BrandName',
//     method: 'GET',
//     params: query
//   })
// }
// 检测是否存在库存
export function IsExistTaskCanAccept(query) {
    return axios({
        url: '/Sale/Task/IsExistTaskCanAccept',
        method: 'GET',
        params: query
    })
}
// 新品首发
export function NewStart(data = {}) {
    return axios({
        url: '/Sale/Sale/NewStart',
        method: 'POST',
        data: data
    })
}
export function NewStartNoLogin(data = {}) {
    return axios({
        url: '/NoAuth/SaleIndex/NewStartNoLogin',
        method: 'POST',
        data: data
    })
}
// 人气推荐
// export function Popularity (data = {}) {
//   return axios({
//     url: '/Sale/Sale/Popularity',
//     method: 'POST',
//     data: data
//   })
// }
// export function PopularityNoLogin (data = {}) {
//   return axios({
//     url: '/NoAuth/SaleIndex/PopularityNoLogin',
//     method: 'POST',
//     data: data
//   })
// }
// 品质专区
export function QualityPage(data = {}) {
    return axios({
        url: '/Sale/Sale/QualityPage',
        method: 'POST',
        data: data
    })
}
export function QualityPageNoLogin(data = {}) {
    return axios({
        url: '/NoAuth/SaleIndex/QualityPageNoLogin',
        method: 'POST',
        data: data
    })
}
// 补贴专区
// export function GetTBKProductSixList (query) {
//   return axios({
//     url: '/NoAuth/TBKProduct/GetTBKProductSixList',
//     method: 'GET',
//     params: query
//   })
// }
// 手动录入模式获取列表数据获取
export function TBKProductList(query) {
    return axios({
        url: '/NoAuth/TBKProduct/TBKProductList',
        method: 'GET',
        params: query
    })
}
// 自动录入模式获取列表数据获取
export function TBKProductListV2(query) {
    return axios({
        url: '/NoAuth/TBKProduct/TBKProductListV2',
        method: 'GET',
        params: query
    })
}
// 补贴商品领券接口
export function GetTLJProductCoupon(data = {}) {
    return axios({
        url: '/Member/TLJProduct/GetTLJProductCoupon',
        method: 'POST',
        data: data
    })
}
// 京东创建礼金链接接口
export function GetJLJProductCoupon(data = {}) {
    return axios({
        url: '/Member/TLJProduct/GetJLJProductCoupon',
        method: 'POST',
        data: data
    })
}
// 免搜字体模糊查询
export function TBKProductListSearch(query) {
    return axios({
        url: '/SaleV2/TBKProduct/TBKProductListSearch',
        method: 'GET',
        params: query
    })
}
export function TBKProductListSearchNoLogin(query) {
    return axios({
        url: '/NoAuth/TBKProduct/TBKProductListSearchNoLogin',
        method: 'GET',
        params: query
    })
}
// export function GetTopSixFreeCardProductList (query) {
//   return axios({
//     url: '/Sale/Sale/GetTopSixFreeCardProductList',
//     method: 'GET',
//     params: query
//   })
// }
// export function GetTopSixFreeCardProductListNoLogin (query) {
//   return axios({
//     url: '/NoAuth/SaleIndex/GetTopSixFreeCardProductListNoLogin',
//     methods: 'GET',
//     params: query
//   })
// }
export function CheckIsOursProduct(query) {
    return axios({
        url: '/NoAuth/TBKProduct/CheckIsOursProduct',
        methods: 'GET',
        params: query
    })
}
// 搜索商品-免搜商品录入
export function GetTBKProductInfoSuper(data = {}) {
    return axios({
        url: '/SaleV2/TBKProduct/GetTBKProductInfoSuper',
        method: 'POST',
        data: data
    })
}
export function GetTBKProductInfoSuperNologin(data = {}) {
    return axios({
        url: '/NoAuth/TBKProduct/GetTBKProductInfoSuper',
        method: 'POST',
        data: data
    })
}
// 首页海报点击记录
export function HomeImageOnClick(query) {
    return axios({
        url: '/Member/SApp/HomeImageOnClick',
        methods: 'GET',
        params: query
    })
}
// 首页海报点击记录(未登录)
export function HomeImageOnClickNoLogin(query) {
    return axios({
        url: '/NoAuth/SaleIndex/HomeImageOnClickNoLogin',
        methods: 'GET',
        params: query
    })
}
// 首页banner图点击记录
export function UploadImgsOnClick(query) {
    return axios({
        url: '/Member/SApp/UploadImgsOnClick',
        methods: 'GET',
        params: query
    })
}
export function HomeImage(query) {
    return axios({
        url: '/NoAuth/SaleIndex/HomeImage',
        methods: 'GET',
        params: query
    })
}
export function HomeImageMarkRead(data = {}) {
    return axios({
        url: '/Member/SApp/HomeImageMarkRead',
        method: 'POST',
        data: data
    })
}

// 新人专享
export function ProductNewPersonShowList(query) {
    return axios({
        url: '/NoAuth/SaleIndex/ProductNewPersonShowList',
        methods: 'get',
        params: query
    })
}

// 商品屏蔽
export function BlockProductAdd(data = {}) {
    return axios({
        url: '/SaleV2/BlockProduct/BlockProductAdd',
        method: 'post',
        data: data
    })
}

// 获取内容列表接口
export function H5ContentListGet(query) {
    return axios({
        url: '/NoAuth/ColumnContent/H5ContentListGet',
        method: 'get',
        params: query
    })
}

// 获取内容详情接口
export function H5ContentGet(query) {
    return axios({
        url: '/Member/ColumnContent/H5ContentGet',
        method: 'get',
        params: query
    })
}

// 内容商品领券接口
export function CententProductGetCoupon(data = {}) {
    return axios({
        url: '/Member/ColumnContent/CententProductGetCoupon',
        method: 'post',
        data: data
    })
}

// 内容分享接口
export function ContentToShare(query) {
    return axios({
        url: '/Member/ColumnContent/ContentToShare',
        method: 'get',
        params: query
    })
}

// 内容点赞接口
export function LikeAdd(query) {
    return axios({
        url: '/Member/ColumnContent/LikeAdd',
        method: 'get',
        params: query
    })
}

// 取消点赞接口
export function LikeSub(query) {
    return axios({
        url: '/Member/ColumnContent/LikeSub',
        method: 'get',
        params: query
    })
}

// 获取淘礼金商品列表接口
export function GetTLJProductList(data = {}) {
    return axios({
        url: '/NoAuth/TLJProduct/GetTLJProductList',
        method: 'post',
        data: data
    })
}

//  获取淘礼金商品详情接口
export function GetTLJProductInfo(data = {}) {
    return axios({
        url: '/NoAuth/TLJProduct/GetTLJProductInfo',
        method: 'post',
        data: data
    })
}